module.exports = __webpack_public_path__ + "static/img/pic.f7d2c9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/pic.png
// module id = Omlc
// module chunks = 37